/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type ApplicationInstance from '@ember/application/instance';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';
import type ProcedurePreviewService from 'embercom/services/procedure-preview-service';
import { registerDestructor } from '@ember/destroyable';

const SET_DATA_EVENT = 'procedure-preview:set-data';
const CLEAR_DATA_EVENT = 'procedure-preview:clear-data';

export default class ProcedurePreviewBridge extends Component {
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;
  @service declare procedurePreviewService: ProcedurePreviewService;

  constructor(owner: ApplicationInstance, args: {}) {
    super(owner, args);

    let unsubscribeSetData = this.reactTeammateAppIsland.subscribeToTeammateAppEvent(
      SET_DATA_EVENT,
      (data: Record<string, unknown>) => {
        this.procedurePreviewService.setProcedureData(
          data.procedureId as string,
          data.draftVersionId as string,
        );
      },
    );

    let unsubscribeClearData = this.reactTeammateAppIsland.subscribeToTeammateAppEvent(
      CLEAR_DATA_EVENT,
      () => {
        this.procedurePreviewService.clearProcedureData();
      },
    );

    registerDestructor(this, () => {
      unsubscribeSetData();
      unsubscribeClearData();
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinAiAgent::Procedures::ProcedurePreviewBridge': typeof ProcedurePreviewBridge;
    'fin-ai-agent/procedures/procedure-preview-bridge': typeof ProcedurePreviewBridge;
  }
}
